module.exports = __webpack_public_path__ + "img/operate5.3f0e5a19.png";